import { AccosBarDataQueryString, FilterPageUrl } from '@/constants'
import { accosBarData, areas } from '@/store/accosbar.store'
import { ENABLEMINIACCOSBAR } from './helpers'

export function redirectToFilterPage(): void {
  const url = new URL(window.location.toString())
  const data = btoa(JSON.stringify(accosBarData.value))
  url.pathname = FilterPageUrl
  url.searchParams.set(AccosBarDataQueryString, data)
  if (window.location.pathname + window.location.search !== url.pathname + url.search) window.location.href = url.pathname + url.search
}

export function getPredefinedSuggestionsOnFocus(pid: number): Array<{ areaId: number; name: string }> | null {
  // suedtirol.com
  // -- 4003 - dolomiten - 228
  // -- 4054 - meran und umgebung - 164
  // -- 4007 - kronplatz - 123
  // -- 4006 - hochpustertal - 22
  // -- 4110 - bozen und umgebung - 14
  // -- 4075 - brixen - 14
  // -- 4087 - sterzing - 12
  // -- 4067 - dorf tirol - 10

  // dolomites.com
  // -- 1305 - tre cime di lavaredo
  // -- 1332 - cortina d'ampezzo
  // -- 1307 - lago di braies
  // -- 1310 - alpe di siusi
  // -- 1312 - val gardena
  // -- 1319 - bolzano
  // -- 1302 - south tyrol
  // -- 1303 - trentino
  // -- 1304 - belluno

  let predefinedAreaIds: number[] = []
  switch (pid) {
    case 4:
      predefinedAreaIds = [4003, 4054, 4007, 4006, 4110, 4075, 4087, 4067]
      break
    case 13:
      predefinedAreaIds = [1305, 1332, 1307, 1310, 1312, 1319, 1302, 1303, 1304]
      break
    default:
      return null
  }
  const filteredAreaIds = areas.value?.filter((x) => predefinedAreaIds.includes(x.areaId))
  return filteredAreaIds ? [...filteredAreaIds] : null
}

let lastScrollY = window.scrollY
export function checkVisibilityAccosBarMini(accosBar: Element | null, smBar: Element | null): boolean {
  if (!accosBar) return false

  const rect = accosBar.getBoundingClientRect()
  const currentScrollY = window.scrollY
  const isScrollingUp = currentScrollY < lastScrollY
  lastScrollY = currentScrollY

  if (rect.bottom <= 50) {
    smBar?.classList.add('show')
    return true
  }

  if (isScrollingUp && rect.bottom > -250 && rect.bottom <= 50) {
    smBar?.classList.remove('show')
    return false
  }

  smBar?.classList.remove('show')
  return rect.bottom <= 200
}

export function stickyAccosBar(element: Element | null): void {
  if (!element) return
  const base = element.parentElement as Element
  if (!base) return

  const previousSelector = element.getAttribute('sticky-accosbar')
  const previous = previousSelector ? document.querySelector(previousSelector) : null

  function render() {
    const prevHeight = previous ? previous.getBoundingClientRect().height : 0
    const baseTop = base.getBoundingClientRect().top + window.scrollY
    const scrollTop = window.scrollY + prevHeight
    const blockBottom = scrollTop - baseTop

    if (previous && previous.getBoundingClientRect().top >= 0) {
      if (element?.classList.contains('fixed')) {
        element?.classList.add('to-bottom')
        setTimeout(() => {
          element?.classList.remove('fixed')
          element?.classList.remove('to-bottom')
        }, 300)
      }
    }

    if (blockBottom == prevHeight && element?.classList.contains('fixed')) {
      element?.classList.add('to-bottom')
      setTimeout(() => {
        element?.classList.remove('fixed')
        element?.classList.remove('to-bottom')
      }, 300)
    } else if (!element?.classList.contains('fixed') && blockBottom > prevHeight) {
      element?.classList.add('to-bottom')
      setTimeout(() => {
        element?.classList.add('fixed')
        element?.classList.remove('to-bottom')
      }, 300)
    }
  }

  if (window.innerWidth > 991 && ENABLEMINIACCOSBAR) {
    render()
  } else {
    element?.classList.remove('fixed')
  }
}
